import { atom } from "recoil";

const startModalCloseState = atom({
  key: "startModalClose",
  default: false,
});

export default startModalCloseState;
